import * as i18nActions from './actions';
import i18n from 'react-intl-universal';
import _ from 'lodash';

const SUPPORTED_LOCALES = process.env.REACT_APP_SUPPORTED_LOCALES.split(',');
const DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE;

let currentLocale = i18n.determineLocale({
  urlLocaleKey: 'lang',
  cookieLocaleKey: 'lang'
});

if (!_.includes(SUPPORTED_LOCALES, currentLocale)) {
  currentLocale = DEFAULT_LOCALE;
}

const initialState = {
  currentLocale: currentLocale,
  supportedLocales: SUPPORTED_LOCALES
};

export default (state = initialState, action) => {
  switch (action.type) {
    case i18nActions.SET_LOCALE:
      return {
        ...state,
        currentLocale: action.lang
      };
    default:
      return state;
  }
};

export function getCurrentLocale(state) {
  return state.currentLocale;
}

export function getSupportedLocales(state) {
  return state.supportedLocales;
}
